import {useStudiengangs} from "@/lib/api";
import {Autocomplete, Skeleton, TextField} from "@mui/material";
import InputLabelStyled from "@/components/InputLabelStyled";
import theme from "@/styles/theme";
import {useContext, useEffect, useState} from "react";
import AppContext from "@/context/AppContext";

export default function StudiengangSelector({
                                                name = "studiengangs", required = false,
                                                defaultValue,
                                                onChange,
                                                maxCount = 4
                                            }) {
    const {studiengangs, isLoading, isError} = useStudiengangs();
    const [helper, setHelper] = useState('Bitte auswählen');
    const {setSnackbar} = useContext(AppContext);
    const [selectedValues, setSelectedValues] = useState([]);

    useEffect(() => {
        if (selectedValues.length > maxCount) {
            setSnackbar({
                type: 'warning',
                content: `Du kannst nur maximal ${maxCount} Studiengänge wählen, alle weiteren werden nicht gespeichert`
            });
        }
        if (selectedValues.length === maxCount) {
            setHelper(`Du kannst maximal ${maxCount} Studiengänge wählen`)
        } else {
            setHelper('Bitte auswählen');
        }
    }, [selectedValues]);

    const handleSelected = (event, values) => {
        let ids = [];
        for (const v of values) {
            ids = [...ids, v.name];
        }

        setSelectedValues(values);

        if (onChange) {
            event.target.name = name;
            event.target.value = ids;
            onChange(event, values)
        }
    };

    if (isLoading) {
        return <Skeleton/>
    }

    return (
        <>
            <InputLabelStyled label="Studiengang" hint="Wähle bis zu vier"/>
            <Autocomplete
                name={name}
                multiple
                options={studiengangs}
                defaultValue={defaultValue}
                getOptionLabel={(option) => `${option.name}`}
                sx={autocomplete}
                onChange={(event, newValues) => {
                    if (newValues.length > maxCount) {
                        newValues.pop();
                    }
                    handleSelected(event, newValues);
                }}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        variant="filled"
                        placeholder={helper}
                    />
                )}
            />
        </>
    )
}

const autocomplete = {
    "& .MuiFilledInput-root": {
        padding: ".1875rem 0 .1875rem 1rem",
        minHeight: "42px",
        "& ::placeholder": {
            color: "#1a1a1a",
            opacity: "1!important",
            textTransform: "uppercase",
            fontSize: "1rem",
        },

        "& input": {
            padding: "unset !important",
        },

        "& .MuiChip-root": {
            height: "1.75rem",
            borderRadius: ".25rem",
            color: theme.palette.common.white,
            margin: ".1875rem .5rem .1875rem 0",
            backgroundColor: theme.palette.primary.main,
        },
    },

    "& label": {
        display: "none",
    },
};
